import { jsx as _jsx } from "react/jsx-runtime";
import { Icon as MuiIcon, } from '@mui/material';
import { styled } from '../../utils';
const IconStyled = styled(MuiIcon)({
    '&.MuiIcon-root': {
        height: 'auto',
        '&::before': {
            lineHeight: 'initial',
        },
    },
    '&.MuiIcon-fontSizeSmall': {
        fontSize: '1rem',
    },
    '&.MuiIcon-fontSizeLarge': {
        fontSize: '2.5rem',
    },
});
export function Icon(props) {
    const { variant, className, ...otherProps } = props;
    // TODO: why do we need a height of 'auto' for this to work?
    return (_jsx(IconStyled, { className: `zi zi-${variant} ${className}`, ...otherProps }));
}
